import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ScrollToTop } from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import StoryPage from "@/pages/StoryPage";
import Community from "@/pages/Community";
import SponsorPage from "@/pages/SponsorPage";
import ManifestoPage from "@/pages/ManifestoPage";
import SocialPage from "@/pages/SocialPage";
import PartnerPage from "@/pages/PartnerPage";
import GuidaPage from "@/pages/GuidaPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminRichieste from "@/pages/AdminRichieste";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";

function App() {
  return (
    <div className="App">
      <TooltipProvider>
        <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/community" element={<Community />} />
          <Route path="/sponsor" element={<SponsorPage />} />
          <Route path="/manifesto" element={<ManifestoPage />} />
          <Route path="/social" element={<SocialPage />} />
          <Route path="/partner" element={<PartnerPage />} />
          <Route path="/donna-impresa" element={<GuidaPage />} />
          <Route path="/racconta-la-tua-storia" element={<StoryPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/richieste" element={<AdminRichieste />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
      </TooltipProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
